<mat-card class="detail-card" valumizeCardContextMenu context="/gp/overview/">
    @let params = params$ | async;
    <mat-card-header class="detail-card-header">
        <mat-card-title data-test="title">General Partner Overview</mat-card-title>
    </mat-card-header>
    <mat-card-content class="detail-card-content">
        <div class="table-toolbar">
            <mat-checkbox color="primary" [(ngModel)]="showArchived" (change)="onArchivedChanged($event)">
                Show Archived
            </mat-checkbox>
            <span class="spacer"></span>
            @if (searchVisible) {
                <input matInput #searchInput id="search-input" class="list-search-input" (input)="onSearchInput($event)" placeholder="Search">
            }
            <valumize-card-comments-button context="/gp/overview/"></valumize-card-comments-button>
            <button mat-icon-button (click)="toggleSearch()" matTooltip="Search">
                <mat-icon>search</mat-icon>
            </button>
            <button mat-icon-button (click)="openTableSettings()" matTooltip="Table Settings">
                <mat-icon>view_column</mat-icon>
            </button>
        </div>

        <div class="table-container">
            @if (isLoading$ | async) {
                <div class="loading-overlay">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>
            }

            <table mat-table [dataSource]="(generalPartners$ | async) ?? []" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortActive" [matSortDirection]="sortDirection">
                <ng-container matColumnDef="gpId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="id">ID</th>
                    <td mat-cell *matCellDef="let element">{{element.id}}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="name">General Partner</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.isArchived?.value) {
                            <mat-icon class="archived-icon">inventory_2</mat-icon>
                        }
                        {{element.name | traceableFormat}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="quality">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="quality">Quality</th>
                    <td mat-cell *matCellDef="let element">{{element.quality.code | codeFormat: codeTableGpQuality | async}}</td>
                </ng-container>

                <ng-container matColumnDef="funds">
                    <th mat-header-cell *matHeaderCellDef>Funds</th>
                    <td mat-cell *matCellDef="let element">{{element.fundNames?.join(', ')}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columns"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: columns"
                    [routerLink]="row.id"></tr>
            </table>
        </div>

        @if (params) {
            <mat-paginator
                [length]="(totalElements$ | async) ?? 0"
                [pageIndex]="params.page"
                [pageSize]="params.size"
                [pageSizeOptions]="[10, 20, 30, 50, 100]"
                showFirstLastButtons
                (page)="onPageChange($event)">
            </mat-paginator>
        }
    </mat-card-content>
    <mat-card-actions class="overview-actions">
        <button mat-stroked-button color="primary" (click)="openNewGeneralPartnerDialog()" data-test="new-GP">
            <mat-icon>add</mat-icon>
            General Partner
        </button>
    </mat-card-actions>
</mat-card>
